<section id='printAll1' *ngIf='show' style="padding: 20px; padding-top: 10px !important;" class='no0'>
    <div class="col-12">
        <div class="card">
            <div class="card-header no" style='padding-top: 0;'>
                <h4 class='mt-1 print' style="float: left;margin-bottom: 10px;">All In Store : </h4>
                <h4 class='mt-1 print' style="float: right;margin-bottom: 5px;"><button (click)='print()' class="p-1 btn btn-secondary" type="submit" style="width: 99%; height: 27px;border: 1px solid black !important;line-height: 0;"><i class="fas fa-print"></i></button></h4>
                <!-- <h4 *ngIf="finished" class='mt-1 print mr-2' style="float: right;margin-bottom: 5px;"><button (click)="qtyFinished()" type="button" class="btn btn-danger" style="height: 27px !important;line-height: 0 !important;box-shadow: 0 0 0 0rem rgb(220 53 69 / 50%) !important;">Items Finished</button></h4>
                <h4 *ngIf="noRepeat" class='mt-1 print mr-2' style="float: right;margin-bottom: 5px;"><button (click)="qtyNoRepeat()" type="button" class="btn btn-danger" style="height: 27px !important;line-height: 0 !important;box-shadow: 0 0 0 0rem rgb(220 53 69 / 50%) !important;">Items</button></h4> -->
                <div style="clear: both;"></div>
                <div *ngIf='false'>
                    <div class="tab-content" id="nav-tabContent">
                        <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                        </div>
                        <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                            <form id="w5" #data='ngForm' (submit)='addS0(data.value)' style="direction: ltr !important;text-align: center;">
                                <span id="form00" style="display: block;">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col-sm-3" style='text-align: center;'>
                          <select id="select00I" [(ngModel)]='supplier' name="supplier" class="form-control mt-2 select2" style="height: unset !important;" (change)='sho(supplierA,supplier)'>
                      <option value="undefined" disabled selected>Supplier</option>
                      <option *ngFor='let r of supplierA' [value]="r.id">{{r.name}}</option>
                      </select>
                        </div>
                        <div class="col-sm-3" style='text-align: center;'>
                          <input  class="text mt-2 d1 mb-2" type="number" placeholder="PI NO : {{piNo + 1}}" required="" disabled>
                        </div>
                        <div class="col-sm-3" style='text-align: center;'>
                          <input *ngIf='OrderDate000' (mouseenter)='OrderDate0010()'  class="text mt-2 d1" type="text" placeholder="Order Date" required="">
                          <input *ngIf='OrderDate010'  class="text mt-2 d1" type="date" name="dateorder" [(ngModel)]='dateorder' required="" value="2021-01-19">
                        </div>
                        <div class="col-sm-3" style='text-align: center;'>
                          <input *ngIf='OrderDate00' (mouseenter)='OrderDate001()'  class="text mt-2 d1" type="text" placeholder="Shipping Date" required="">
                          <input *ngIf='OrderDate01'  class="text mt-2 d1" type="date" name="datereceipt" [(ngModel)]='datereceipt' required="" value="2021-01-30">
                        </div>

                        <div class="col-sm-3" style='text-align: center;'>
                          <input  class="text mt-2 d1" type="text" name="codeOut" [(ngModel)]='codeOut' placeholder="Item Code" required="">
                        </div>
                        <div class="col-sm-3" style='text-align: center;'>
                          <input  class="text mt-2 d1" type="text" name="description" [(ngModel)]='description' placeholder="Description" required="">
                        </div>
                        <div class="col-sm-3" style='text-align: center;'>
                          <input  class="text mt-2 d1 mb-2" type="text" name="dimensions" [(ngModel)]='dimensions' placeholder="Dimensions" required="">
                        </div>
                        <div class="col-sm-3" style='text-align: center;'>
                          <input  class="text mt-2 d1" type="text" name="fabric" [(ngModel)]='fabric' placeholder="Finishing/fabrics	" required="">
                        </div>
                        <div class="col-sm-3 mt-2" style='text-align: center;'>
                          <select id="select00I0" [(ngModel)]='category' name="category" class="form-control mt-1 select2" style="height: unset !important;">
                            <option value="undefined" disabled selected>Category</option>
                            <option *ngFor='let r of allCa' [value]="r.id">{{r.name}}</option>
                            </select>
                          </div>
                          <div class="col-sm-2" style='text-align: center;'>
                            <input  class="text mt-2 d1 mb-2" type="number" name="qty" [(ngModel)]='qty' placeholder="Qty" required="" style="height: 54px;">
                          </div>
                          <div class="col-sm-2" style='text-align: center;'>
                            <input  class="text mt-2 d1 mb-2" type="number" name="price" [(ngModel)]='price' placeholder="Price" required="" style="height: 54px;">
                          </div>
                          <div class="col-sm-2" style='text-align: center;'>
                            <input (click)='OrderDate00100()'  class="text mt-2 d1" type="text" placeholder="Images" required="" style="height: 54px;">
                            <input style="overflow: hidden !important; display: none !important;" id="im0" (change)='img($event)'  class="text mt-2 d1" type="file" accept="image/*" placeholder="الصور" required="" multiple>
                            <a *ngFor='let s of countImage; let x = index' id="but{{x}}"  class="but mt-2"><i class="fas fa-plus-circle"></i>
                              <img draggable="false" id="put44{{x}}" style="width: 100%; display: block; height: 100%;">
                            </a>
                          </div>
                          <div class="col-sm-3 mt-2" style='text-align: center;'>
                            <select id="select00I00" [(ngModel)]='root' name="root" class="form-control mt-2 select2" style="height: unset !important;">
                              <option value="undefined" disabled selected>Branch</option>
                              <option *ngFor='let x of rootA' [value]="x.id">{{x.name}}</option>
                        </select>
                      </div>
                      </div>
                    </div>
          <input style="margin-top: .5rem !important;width: 20% !important; margin-bottom:0 !important;" type="submit" value="Add">
          <div style="clear: both;"></div>
          </span>
                            </form>


                        </div>
                        <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                            <form id='e5' #dataF='ngForm' (submit)='addS0F(dataF.value)' style="direction: ltr !important;">
                                <span id="form00" style="display: block; text-align: center;">
                            <div class='container-fluid'>
                              <div class="row">
                                <div class="col-sm-3 mt-2" style='text-align: center;'>
                                  <select id="select00IJJ" [(ngModel)]='supplier' name="supplier" class="form-control mt-2 select2" style="height: unset !important;" (change)='sho(supplierA,supplier)'>
                              <option value="undefined" disabled selected>Supplier</option>
                              <option *ngFor='let r of supplierA' [value]="r.id">{{r.name}}</option>
                              </select>
                                </div>
                                <div class="col-sm-2" style='text-align: center;'>
                                  <input style='height: 54px;'  class="text mt-2 d1 mb-2" type="number" placeholder="PI NO : {{piNo + 1}}" required="" disabled>
                                </div>
                                <div class='col-sm-2'>
                                  <input style='height: 54px;' *ngIf='OrderDate000' (mouseenter)='OrderDate0010()'  class="text mt-2 d1" type="text" placeholder="Order Date" required="">
                                  <input style='height: 54px;' *ngIf='OrderDate010'  class="text mt-2 d1" type="date" name="dateorder" [(ngModel)]='dateorder' required="" value="2021-01-19">                                  </div>
                                <div class='col-sm-2'>
                                  <input style='height: 54px;' *ngIf='OrderDate00' (mouseenter)='OrderDate001()'  class="text mt-2 d1" type="text" placeholder="Shipping Date" required="">
                          <input style='height: 54px;' *ngIf='OrderDate01'  class="text mt-2 d1" type="date" name="datereceipt" [(ngModel)]='datereceipt' required="" value="2021-01-30">
                                </div>
                                <div class='col-sm-3'>
                                  <input id='fgy' style="overflow: hidden !important;height:54px;display: none !important;" name='excel' (change)='goFile($event)'   class="text mt-2 d1" type="file" placeholder="الصور" required="">
                                  <button onclick='$("#fgy").trigger("click")' style="height: 54px !important; width: 94.5% !important;border: 1px solid black !important; " type="button" class="btn btn-secondary mb-2 mt-2">Add File Excel</button>
                                </div>
                              </div>
                            </div>

            <input style="margin-top: .5rem !important;width: 20% !important; margin-bottom: .5rem;" type="submit" value="Add">
            <div style="clear: both;"></div>
            </span>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="container-fluid print" style="padding: 0 !important;">
                    <div class="row">
                        <div class="col-lg-2 col-12">
                            <input style="height: 20px;" *ngIf='OrderDate000S' (mouseenter)='OrderDate0010S()' class="text d1 mb-2" type="text" placeholder="From Date" required="">
                            <input *ngIf='OrderDate000S0' (change)='goDate()' id="fromDG" placeholder="Search By Code" class="p-1 mb-2 fromDA" type="date" style="width: 94.5% !important; height: 27px;border: 1px solid black !important; color: black !important;">
                        </div>
                        <div class="col-lg-2 col-12">
                            <input style="height: 20px;" *ngIf='OrderDate000SS' (mouseenter)='OrderDate0010SS()' class="text d1 mb-2" type="text" placeholder="To Date" required="">
                            <input *ngIf='OrderDate000SS0' (change)='goDate()' id="toDG" placeholder="Search By Code" class="p-1 mb-2 toDA" type="date" style="width: 94.5% !important; height: 27px;border: 1px solid black !important; color: black !important;">
                        </div>
                        <div class="col-lg-2 col-12 mb-2 lastU">
                            <select [(ngModel)]='serchCode' class="form-control mb-2 select2 selectsearchroot000" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                            <option disabled selected value="undefined">Search By Code</option>
                            <option>All</option>
                            <option *ngFor='let w of arre' [value]="w.code">{{w.code}}</option>
                          </select>
                        </div>
                        <div class="col-lg-2 col-12 mb-2 lastU">
                            <select [(ngModel)]='placeSearch' class="form-control mb-2 select2 selectsearchroot" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
              <option disabled>Search By Branch</option>
              <input type='text'>
              <option>All</option>
              <option *ngFor='let w of rootA' [value]="w.id">{{w.name}}</option>
      </select>
                        </div>
                        <div class="col-lg-2 col-12 mb-2 lastU">
                            <select [(ngModel)]='searchsupplier' class="form-control mb-2 select2 selectsearchsupplier" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
            <option disabled>Search By Supplier</option>
            <option>All</option>
            <option *ngFor='let w of supplierA' [value]="w.id">Name : {{w.name}} || code : {{w.id}}</option>
    </select>
                        </div>
                        <div class="col-lg-1 col-12 mb-2 lastU">
                            <select class="form-control mb-2 select2 selectpin" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
          <option value="undefined" disabled selected>PI NO</option>
          <option>All</option>
          <option *ngFor='let w of pi; let e = index' [value]="e+1">{{e+1}}</option>
  </select>
                        </div>
                        <div class="col-lg-1 col-12 mb-2 lastU">
                            <select class="form-control mb-2 select2 selectpin0" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
        <option value="undefined" disabled selected>Category</option>
        <option>All</option>
        <option *ngFor='let w of allCa;' [value]="w.id">{{w.name}}</option>
</select>
                        </div>
                    </div>
                </div>

            </div>
            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 67.2vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No.</th>
                                    <th scope="col">Code</th>
                                    <th scope="col">Branch</th>
                                    <th scope="col">In_Qty</th>
                                    <th scope="col">Available</th>
                                    <th scope="col">Defect</th>
                                    <th scope="col">Notes</th>
                                    <th scope="col">Reseved</th>
                                    <th scope="col">Sales</th>
                                    <th scope="col" class='no'>Photo</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of arre|categorySearch:categorySearch|serchCode:serchCode|placeSearch:placeSearch|searchSupplier:searchsupplier|selectpin:selectpin|dateCom:dateFrom:dateTo; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Code">{{v.code}}</td>
                                    <td data-title="Branch">{{v.rootname}}</td>
                                    <td data-title="In Qty">{{v.mainqty}}</td>
                                    <td data-title="Available">{{v.qty}}</td>
                                    <td data-title="Defect">{{v.defect}}</td>
                                    <td data-title="Notes">
                                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.notes}}</a></div>
                                    </td>
                                    <td data-title="Reseved" (click)='waw(v)' style='cursor: pointer;'>{{v.mainqty - (v.qty + v.qtyfinish)}}</td>
                                    <td data-title="Sales" (click)='waw0(v)' style='cursor: pointer;'>{{v.qtyfinish}}</td>
                                    <td data-title="Photo" class='no'>
                                        <img class='shadow-lg' (click)='showpho(v.id)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:60px;height:60px;cursor: pointer;' [src]='(v.url != null) ? v.url : "../../assets/video/noimage.jpg" '>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
        </div>
    </div>
</section>
<section class="loading">
    <div class="spinner">
        <div class="sk-circle">
            <div class="sk-circle1 sk-child"></div>
            <div class="sk-circle2 sk-child"></div>
            <div class="sk-circle3 sk-child"></div>
            <div class="sk-circle4 sk-child"></div>
            <div class="sk-circle5 sk-child"></div>
            <div class="sk-circle6 sk-child"></div>
            <div class="sk-circle7 sk-child"></div>
            <div class="sk-circle8 sk-child"></div>
            <div class="sk-circle9 sk-child"></div>
            <div class="sk-circle10 sk-child"></div>
            <div class="sk-circle11 sk-child"></div>
            <div class="sk-circle12 sk-child"></div>
        </div>
    </div>
</section>
<section id="upd-dd">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closedd()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <span id="form00" style="display: block;">
          <input (click)='ok()' style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Delete confirmation">
          <div style="clear: both;"></div>
          </span>
            </div>
        </div>
    </div>
</section>
<section id="upd-up">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeUpI()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <form #data00='ngForm' (submit)='okUp(data00.value)' style="direction: ltr !important;">
                    <span id="form00" style="display: block;">
                    <input  class="text mt-2 d1" type="text" name="descriptionU" [(ngModel)]='descriptionU' placeholder="Description" required="">
                    <input  class="text mt-2 d1" type="text" name="dimensionsU" [(ngModel)]='dimensionsU' placeholder="Dimensions" required="">
                    <input  class="text mt-2 d1" type="text" name="fabricU" [(ngModel)]='fabricU' placeholder="Finishing/fabrics" required="">
                    <input  class="text mt-2 d1" type="number" name="qtyU" [(ngModel)]='qtyU' placeholder="Qty" required="">
                    <ng-container *ngIf='imageShowU'>
                    <input style="overflow: hidden !important;" id="im00" (change)='img0($event)'  class="text mt-2 d1" type="file" accept="image/*" placeholder="الصور" required="" multiple>
                    <a *ngFor='let s of countImage0; let x = index' id="but0{{x}}"  class="but0 mt-1"><i class="fas fa-plus-circle"></i>
                      <img draggable="false" id="put440{{x}}" style="width: 100%; display: block; height: 100%;">
                    </a>
                  </ng-container>
                    <ng-container *ngIf='imgget'>
                        <div style='display: inline-block' *ngFor='let r of arrI;let f = index'class='asd00{{f}}'>
                        <a class="but" style="display: inline-block !important; position: relative;">
                          <span class="asd" style="position: absolute; top: 0; right: 0;width: 100%;height: 100%; background: rgba(0, 0, 0, 0.8)">
                            <i (click)='deleteImage(r.id , f)' style='color: red; font-size: 13px;position: absolute; top:5%;right: 45%; z-index:200000;' class="fas fa-trash-alt"></i>
                          </span>
                    <img style="width: 100%; height: 100% !important; display: block;" [src]="r.url">
                    </a>
            </div>
            </ng-container>
            <select [(ngModel)]='rootU0' name="rootU0" class="form-control mt-4" style="height: unset !important;">
            <option disabled>Branch</option>
            <option *ngFor='let x of rootA' [value]="x.id">{{x.name}}</option>
      </select>
            <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Update">
            <div style="clear: both;"></div>
            </span>
            </form>
        </div>
    </div>
    </div>
</section>
<section id="updPho" style="text-align: center !important;">
    <button (click)='closePhot()' type="button" class="btn btn-danger m-4" style="box-shadow: none;display: inline;position: fixed;top: 0;left:0;z-index: 20000 !important;"><i class="fas fa-times " style="color: white; cursor: pointer;"></i></button>
    <div style="text-align: center !important; overflow: hidden !important;width: 100%;height: 100%;">
        <div style="display: inline-block; overflow: hidden !important;width: 100%;height: 100%;" id="carouselExampleControls" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner" *ngIf='qwss' style="height: 100%;width: 100%;">
                <div class="carousel-item active" style="height: 100%;width: 100%;">
                    <img [src]="arrImage[0].url" class="d-block" alt="..." style='margin: auto;position: absolute;top: 0;left: 0;right: 0;bottom: 0;'>
                </div>
                <div *ngFor='let f of arrImage|slice:1; let ff = index;' class="carousel-item" style="height: 100%;width: 100%;">
                    <img [src]="arrImage[ff + 1].url" class="d-block" alt="..." style='margin: auto;position: absolute;top: 0;left: 0;right: 0;bottom: 0;'>
                </div>
            </div>
            <a style="margin:auto;margin-left:20px;display: inline-block;width: 40px;height: 40px; background-color:gray; border-radius:50%;" class="carousel-control-prev shadow-lg" href="#carouselExampleControls" role="button" data-slide="prev">
                <span style="margin-top: 25%;" class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a style="margin:auto;margin-right:20px;display: inline-block;width: 40px;height: 40px; background-color:gray; border-radius:50%;" class="carousel-control-next shadow-lg" href="#carouselExampleControls" role="button" data-slide="next">
                <span style="margin-top: 25%;" class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
</section>
<section id="upd-ddO00">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeddP()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <span id="form00" style="display: block;">
              <input  class="text mt-2 d1" type="number" name="discoundPrint" [(ngModel)]='discoundPrint' placeholder="Discound" required="">
        <input (click)='okP()' style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Print">
        <div style="clear: both;"></div>
        </span>
            </div>
        </div>
    </div>
</section>

<div id="printall" style="width: 500px;height: 300px;display: none;margin: 0 auto;" class="p-3 mt-5">
    <h2 style="text-align: center;" class="mb-3">NOGAL FURNITURE</h2>
    <p style="color: black;">{{categoryPrint}}</p>
    <p style="color: black;">Dim : {{dimPrint}}</p>
    <svg id="barcode" class="mt-3 mb-3"></svg>
    <p style="color: black;"><span *ngIf='dis'>Price : </span> {{pricePrint}}</p>
    <p style="color: black;" *ngIf='dis'><span>After : </span> {{pricePrint0}}</p>

</div>
<section id="upd023" style="overflow-y: scroll;">


    <div class="card-body card text-center m-5" style="padding: 10px !important;">
        <i (click)='close0093()' class="fas fa-times m-4" style="color: black; cursor: pointer; text-align: right;"></i>
        <h2 class='mb-2'>Item Code : {{codeShow}} || Branch : {{branch}}</h2>
        <div class="table-responsive dfg" style="overflow: auto;height: 450px;">


            <div class="container" style="margin: 0 !important;max-width:100% !important;">
                <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                    <thead>
                        <tr>
                            <th scope="col" style='text-align: center;'>Quotation_No</th>
                            <th scope="col">Customer_Name</th>
                            <th scope="col">Qty</th>
                            <th scope="col">Booking_Date</th>
                            <th scope="col">Booking_price</th>
                            <th scope="col">Paid_Up</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor='let v of arre0009|searchSupplier:searchsupplier let n = index;'>
                            <td (click)='waw0show(v.id_boked)' data-title="QUotation_No" style='text-align: center;cursor: pointer;'>{{v.id_boked}}</td>
                            <td data-title="Customer_Name">{{v.username}}</td>
                            <td data-title="Qty">{{v.qty}}</td>
                            <td data-title="Booking_Date">{{v.dateB|date:"dd-MM-yyyy"}}</td>
                            <td data-title="Booking_price">{{v.totalB - (v.totalB* (v.discoundB/100))}}</td>
                            <td data-title="Paid_Up">{{v.payB}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
</section>
<section id="upd023show" style="overflow-y: scroll;">


    <div class="card-body card text-center m-5" style="padding: 10px !important;">
        <i (click)='close0093show()' class="fas fa-times m-4" style="color: black; cursor: pointer; text-align: right;"></i>
        <div class="table-responsive dfg" style="overflow: auto;height: 450px;">


            <div class="container" style="margin: 0 !important;max-width:100% !important;">
                <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                    <thead>
                        <tr>
                            <th style="text-align: center;">No.</th>
                            <th scope="col">Item_Code</th>
                            <th scope="col">Branch</th>
                            <th scope="col">Description</th>
                            <th scope="col">Finishing/fabrics</th>
                            <th scope="col">Price</th>
                            <th scope="col">Qty</th>
                            <th scope="col">Total_Coast</th>
                            <th scope="col">Price_Seller</th>
                            <th scope="col">Net_Amount</th>
                            <th scope="col">Photo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor='let v of arre0009show|searchSupplier:searchsupplier let n = index;'>
                            <th scope="row" style="text-align: center;">{{n+1}}</th>
                            <td data-title="Item_Code">{{v.itemcode}}</td>
                            <td data-title="Branch">{{v.rootname}}</td>
                            <td data-title="Description">
                                <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                            </td>
                            <td data-title="Finishing/fabrics">
                                <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.fabric}}</a></div>
                            </td>
                            <td data-title="Price">{{v.price}}</td>
                            <td data-title="Qty">{{v.qty}}</td>
                            <td data-title="Total_Coast">{{v.price * v.qty}}</td>
                            <td data-title="Discound">{{v.priceSeller}}</td>
                            <td data-title="Net_Amount">{{v.total}}</td>
                            <td data-title="Photo">
                                <img class='shadow-lg' (click)='showpho(v.id_item)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:50px;height:50px;cursor: pointer;' [src]='(v.url != null) ? v.url : "../../assets/video/noimage.jpg" '>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <img *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>
</section>